/* eslint-disable */
import React from 'react'
import {Pagination} from 'antd'

class Pageing extends React.Component {
  constructor(props) {
    super(props)
  }

  setPage(pageNumber) {
    this.props.getPage(pageNumber)
  }

  render() {
    let {total, currentPage, pageSize} = this.props

    console.log(currentPage)

    return (
      <div>
        <Pagination
          total={total}
          showQuickJumper
          current={currentPage}
          pageSize={pageSize}
          onChange={this.setPage.bind(this)}
        />
        <br />
        <p className="small mb-0 font-weight-bold">{'تعداد ' + this.props.total + '  سطر یافت شد.'}</p>
      </div>
    )
  }
}

export default Pageing
